// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1gwY9","actions":"GroupTable_actions__t0W75","deleteModalFooter":"GroupTable_deleteModalFooter__2k5YT"};